import React, { Component } from "react";
import classNames from "classnames";
import { MasterTopbar } from "./MasterTopbar";
import { MasterInlineProfile } from "./MasterInlineProfile";
//import { MasterFooter } from "./MasterFooter";
//import { DetailsFooter } from "./DetailsFooter";
import { MasterMenu } from "./MasterMenu";
import "primereact/resources/primereact.min.css";
import "fullcalendar/dist/fullcalendar.css";
import "primeicons/primeicons.css";
import { Route } from "react-router-dom";
import { Dashboard } from "./components/Dashboard/Dashboard";
import { Clients } from "./components/Clients/Clients";
import { CustomerProvider } from "./components/Customer/CustomerProvider";
import { ClientUsers } from "./components/Clients/ClientUsers";
import { ClientSites } from "./components/Clients/ClientSites";
import { ClientBuildings } from "./components/Clients/ClientBuildings";
import { ClientLocations } from "./components/Clients/ClientLocations";
import { Contractors } from "./components/Contractors/Contractors";
import { ContractorUsers } from "./components/Contractors/ContractorUsers";
import { Employees } from "./components/Employees/Employees";
import { UserProvider } from "./components/User/UserProvider";
import { Business } from "./components/Business/Business";
import { DeliveryProvider } from "./components/Deliverys/DeliveryProvider";
import { AttributeProvider } from "./components/Attributes/AttributeProvider";
import { Stock } from "./components/Stock/Stock";
import { Goods } from "./components/Goods/Goods";
import { GoodsInProvider } from "./components/GoodsIn/GoodsInProvider";
import { QualityProvider } from "./components/Quality/QualityProvider";
import { TasksProvider } from "./components/Tasks/TasksProvider";
// import { Buildings } from "./components/Sites/legacy/Buildings";
// import { Locations } from "./components/Sites/legacy/Locations";
import { GoodsComplete } from "./components/Goods/GoodsComplete";
import { EmptyPage } from "./components/EmptyPage";
import { SiteProvider } from "./components/Sites/SiteProvider";
import { ChartsV2 } from "./components/Statistics/Chartsv2";
import { Statistics } from "./components/Statistics/StatisticsDashboard";
import { AnalyticsProvider } from "./components/Analytics/AnalyticsProvider";
import { StationProvider } from "./components/Stations/StationProvider";
import { ToolsProvider } from "./components/Tools/ToolsProvider";
import { ProductProvider } from "./components/Products/ProductProvider";
import { SupplierProvider } from "./components/Supplier/SupplierProvider";
import { PartProvider } from "./components/Part/PartProvider";
import { CatalogueProvider } from "./components/Catalogues/CatalogueProvider";
import { Categorys } from "./components/Catalogues/legacy/Categories";
import { AttributeSetProvider } from "./components/AttributeSet/AttributeSetProvider";
import { OrderProvider } from "./components/Orders/OrderProvider";
import { ScrollPanel } from "primereact/components/scrollpanel/ScrollPanel";
import { logout } from "./common/helpers/auth";
import { Works } from "./components/Work/Works";
import { WorksAssign } from "./components/Work/WorksAssign";
import { WorksSchedule } from "./components/Work/WorksSchedule";
import { ToggleState } from "./common/config/AppConstants";
import * as format from "./common/FormatFunctions";
import "./ripple.js";
import "./Master.css";
import "./components/Styling/styling.css";
import { ToolMetrics } from "./components/Tools/ToolMetrics";
import { OperatorMetrics } from "./components/Operator/OperatorMetrics";
import { Payables } from "./components/Payable/Payables";
import { Receiveables } from "./components/Receivable/Receiveables";
import { InvoiceProvider } from "./components/Invoice/InvoiceProvider";

class Master extends Component {
  constructor() {
    super();
    this.state = {
      layoutMode: "overlay",
      profileMode: "inline",
      overlayMenuActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      rotateMenuButton: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      darkMenu: true,
      rightPanelActive: false,
      menuActive: false,
      hideTopbarFlag: ToggleState.ON
    };

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onTopbarMenuButtonClick = this.onTopbarMenuButtonClick.bind(this);
    this.onTopbarItemClick = this.onTopbarItemClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
    this.onRightPanelButtonClick = this.onRightPanelButtonClick.bind(this);
    this.onRightPanelClick = this.onRightPanelClick.bind(this);
    this.createMenu();
  }

  onMenuClick(event) {
    this.menuClick = true;

    if (!this.isHorizontal()) {
      setTimeout(() => {
        this.layoutMenuScroller.moveBar();
      }, 500);
    }
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.setState({
      rotateMenuButton: !this.state.rotateMenuButton,
      topbarMenuActive: false
    });

    if (this.state.layoutMode === "overlay") {
      this.setState({
        overlayMenuActive: !this.state.overlayMenuActive
      });
    } else {
      if (this.isDesktop())
        this.setState({
          staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive
        });
      else
        this.setState({
          staticMenuMobileActive: !this.state.staticMenuMobileActive
        });
    }

    event.preventDefault();
  }

  onTopbarMenuButtonClick(event) {
    this.topbarItemClick = true;
    this.setState({ topbarMenuActive: !this.state.topbarMenuActive });
    this.hideOverlayMenu();
    event.preventDefault();
  }

  onTopbarItemClick(event) {
    this.topbarItemClick = true;

    if (this.state.activeTopbarItem === event.item)
      this.setState({ activeTopbarItem: null });
    else this.setState({ activeTopbarItem: event.item });

    event.originalEvent.preventDefault();
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.hideOverlayMenu();
    }
    if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
      this.setState({
        menuActive: false
      });
    }
  }

  onRootMenuItemClick(event) {
    this.setState({
      menuActive: !this.state.menuActive
    });

    event.originalEvent.preventDefault();
  }

  onRightPanelButtonClick(event) {
    this.rightPanelClick = true;
    this.setState({
      rightPanelActive: !this.state.rightPanelActive
    });
    event.preventDefault();
  }

  onRightPanelClick(event) {
    this.rightPanelClick = true;
  }

  onDocumentClick(event) {
    if (!this.topbarItemClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false
      });
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.setState({
          menuActive: false
        });
      }

      this.hideOverlayMenu();
    }

    if (!this.rightPanelClick) {
      this.setState({
        rightPanelActive: false
      });
    }

    this.topbarItemClick = false;
    this.menuClick = false;
    this.rightPanelClick = false;
  }

  hideOverlayMenu() {
    this.setState({
      rotateMenuButton: false,
      overlayMenuActive: false,
      staticMenuMobileActive: false
    });
  }

  isTablet() {
    let width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isOverlay() {
    return this.state.layoutMode === "overlay";
  }

  isHorizontal() {
    return this.state.layoutMode === "horizontal";
  }

  isSlim() {
    return this.state.layoutMode === "slim";
  }

  changeTheme(theme) {
    this.changeStyleSheetUrl("layout-css", theme, "layout");
    this.changeStyleSheetUrl("theme-css", theme, "theme");
  }

  changeStyleSheetUrl(id, value, prefix) {
    let element = document.getElementById(id);
    let urlTokens = element.getAttribute("href").split("/");
    urlTokens[urlTokens.length - 1] = prefix + "-" + value + ".css";
    let newURL = urlTokens.join("/");
    element.setAttribute("href", newURL);
  }

  createMenu() {
    this.menu = [
      {
        label: "Dashboard",
        icon: "dashboard",
        command: () => {
          window.location = "#/";
        }
      },
      {
        break: true,
        header: "Operations",
        label: "Orders",
        icon: "inbox",
        command: () => {
          window.location = "#/orders";
        }
      },
      {
        label: "Production",
        icon: "business",
        items: [
          {
            label: "Production Overview",
            icon: "build",
            command: () => (window.location = "#/workSchedule")
          }
        ]
      },
      {
        label: "Dispatches",
        icon: "local_shipping",
        command: () => {
          window.location = "#/deliverys";
        }
      },
      {
        label: "Goods In",
        icon: "subdirectory_arrow_left",
        command: () => {
          window.location = "#/goodsIn";
        }
      },
      /* {
        label: "New Tools",
        icon: "device_hub",
        command: () => {
          window.location = "#/tools";
        }
      }, */
      {
        label: "Stations",
        icon: "device_hub",
        command: () => {
          window.location = "#/tools";
        }
      },
      {
        label: "Operators",
        icon: "group",
        command: () => {
          window.location = "#/operators";
        }
      },
      {
        label: "Products",
        icon: "storefront",
        command: () => {
          window.location = "#/products";
        }
      },
      {
        label: "Parts",
        icon: "storefront",
        command: () => {
          window.location = "#/parts";
        }
      },
      {
        break: true,
        header: "Resolution Centre",
        label: "Quality",
        icon: "assignment_late",
        command: () => {
          window.location = "#/quality";
        }
      },
      {
        label: "Tasks",
        icon: "hourglass_empty",
        command: () => {
          window.location = "#/tasks";
        }
      },
      {
        break: true,
        header: "Vendors",
        label: "Customers",
        icon: "person",
        command: () => {
          window.location = "#/customers";
        }
      },
      {
        label: "Suppliers",
        icon: "person_outline",
        command: () => {
          window.location = "#/suppliers";
        }
      },
      {
        break: true,
        header: "Accounts",
        label: "Payables",
        icon: "folder_open",
        command: () => {
          window.location = "#/payables";
        }
      },
      {
        label: "Receivables",
        icon: "folder_open",
        command: () => {
          window.location = "#/receiveables";
        }
      },
      {
        break: true,
        header: "Reports",
        label: "Analytics",
        icon: "grain",
        command: () => {
          window.location = "#/analytics";
        }
      }
      // {
      //   label: "Statistics",
      //   icon: "grain",
      //   command: () => {
      //     window.location = "#/analytics";
      //   }
      // }
    ];
  }

  toggleOverlayTopbar = value => {
    if (format.isNotNull(value)) {
      this.setState({ hideTopbarFlag: value });
    } else {
      var currentFlag = this.state.hideTopbarFlag;
      if (currentFlag === ToggleState.ON) {
        this.setState({ hideTopbarFlag: ToggleState.OFF });
      }
      if (currentFlag === ToggleState.OFF) {
        this.setState({ hideTopbarFlag: ToggleState.ON });
      }
    }
  };

  render() {
    let layoutContainerClassName = classNames("layout-container", {
      "menu-layout-static": this.state.layoutMode !== "overlay",
      "menu-layout-overlay": this.state.layoutMode === "overlay",
      "layout-menu-overlay-active": this.state.overlayMenuActive,
      "menu-layout-slim": this.state.layoutMode === "slim",
      "menu-layout-horizontal": this.state.layoutMode === "horizontal",
      "layout-menu-static-inactive": this.state.staticMenuDesktopInactive,
      "layout-menu-static-active": this.state.staticMenuMobileActive
    });
    let menuClassName = classNames("layout-menu", {
      "layout-menu-dark": this.state.darkMenu
    });

    return (
      <div className="layout-wrapper" onClick={this.onDocumentClick}>
        <div
          ref={el => (this.layoutContainer = el)}
          className={layoutContainerClassName}
        >
          {this.state.hideTopbarFlag === ToggleState.ON && (
            <MasterTopbar
              profileMode={this.state.profileMode}
              horizontal={this.props.horizontal}
              topbarMenuActive={this.state.topbarMenuActive}
              activeTopbarItem={this.state.activeTopbarItem}
              onMenuButtonClick={this.onMenuButtonClick}
              onTopbarMenuButtonClick={this.onTopbarMenuButtonClick}
              onTopbarItemClick={this.onTopbarItemClick}
              onRightPanelButtonClick={this.onRightPanelButtonClick}
            />
          )}

          <div className={menuClassName} onClick={this.onMenuClick}>
            <ScrollPanel
              ref={el => (this.layoutMenuScroller = el)}
              style={{ height: "100%" }}
            >
              <div className="menu-scroll-content">
                {this.state.profileMode === "inline" &&
                  this.state.layoutMode !== "horizontal" && (
                    <MasterInlineProfile />
                  )}
                <MasterMenu
                  model={this.menu}
                  onMenuItemClick={this.onMenuItemClick}
                  onRootMenuItemClick={this.onRootMenuItemClick}
                  layoutMode={this.state.layoutMode}
                  active={this.state.menuActive}
                />
                <hr></hr>
                <div className="ui-g-12" style={{ color: "white" }}>
                  <label>{"BPMBuild V1.0.0"}</label>
                </div>
              </div>
            </ScrollPanel>
          </div>

          <div className="layout-main">
            <Route path="/" exact component={Dashboard} />
            <Route path="/clients" exact component={Clients} />
            <Route
              path="/customers"
              render={props => (
                <CustomerProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route path="/dashboard" exact component={Dashboard} />
            <Route path="/clientUsers" exact component={ClientUsers} />
            <Route path="/clientSites" exact component={ClientSites} />
            <Route path="/clientBuildings" exact component={ClientBuildings} />
            <Route path="/clientLocations" exact component={ClientLocations} />
            {/* <Route path="/buildings" exact component={Buildings} /> */}
            {/* <Route path="/locations" exact component={Locations} /> */}
            <Route path="/contractors" exact component={Contractors} />
            <Route path="/contractorUsers" exact component={ContractorUsers} />
            <Route path="/employees" exact component={Employees} />
            <Route
              path="/users"
              render={props => (
                <UserProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route path="/business" exact component={Business} />
            <Route
              path="/suppliers"
              render={props => (
                <SupplierProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route path="/categorys" exact component={Categorys} />
            <Route path="/pending" exact component={EmptyPage} />
            <Route
              path="/sites"
              render={props => (
                <SiteProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/catalogues"
              render={props => (
                <CatalogueProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/products"
              render={props => (
                <ProductProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/parts"
              render={props => (
                <PartProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/deliverys"
              render={props => (
                <DeliveryProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/tools"
              render={props => (
                <ToolMetrics
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/stations"
              render={props => (
                <StationProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />{" "}
            <Route
              path="/operators"
              render={props => (
                <OperatorMetrics
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/attributes"
              render={props => (
                <AttributeProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/orders"
              render={props => (
                <OrderProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/attributeSets"
              render={props => (
                <AttributeSetProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            {/* <Route path="/attributes" exact component={AttributesV2} /> */}
            <Route path="/works" exact component={Works} />
            <Route path="/workAssign" exact component={WorksAssign} />
            <Route path="/workSchedule" exact component={WorksSchedule} />
            <Route path="/charts" exact component={ChartsV2} />
            <Route path="/statistics" exact component={Statistics} />
            <Route path="/payables" exact component={Payables} />
            {/* <Route path="/receiveables" exact component={Receiveables} /> */}
            <Route
              path="/receiveables"
              render={props => (
                <InvoiceProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/analytics"
              render={props => (
                <AnalyticsProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route path="/stock" exact component={Stock} />
            <Route path="/goods" exact component={Goods} />
            <Route
              path="/goodsIn"
              render={props => (
                <GoodsInProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/quality"
              render={props => (
                <QualityProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route
              path="/tasks"
              render={props => (
                <TasksProvider
                  {...props}
                  toggleTopbar={this.toggleOverlayTopbar}
                />
              )}
            />
            <Route path="/goodsComplete" exact component={GoodsComplete} />
            {/* <DetailsFooter /> */}
            {/* <MasterFooter /> */}
          </div>

          <div className="layout-mask" />
        </div>
      </div>
    );
  }
}

export default Master;



// WEBPACK FOOTER //
// ./src/Master.js